<template>
  <div>
    <el-tabs v-model="activeTab" @tab-click="handleClick">
      <el-tab-pane class="row" label="Affiliates" name="Affiliates">
        <Affiliates-Card class="col-md-11" singleView/>
      </el-tab-pane>
      <el-tab-pane class="row" label="Invitations" name="Invitations">
        <Affiliate-Invitations-Card class="col-md-11" singleView/>
      </el-tab-pane>
      <el-tab-pane class="row" label="Leads" name="Leads">
        <Leads-Card class="col-md-11 ml-0"/>
      </el-tab-pane>
      <el-tab-pane :label="toReceiveLabel" name="To Receive">
        <Leads-Card toReceiveOnly/>
      </el-tab-pane>
      <!-- <el-tab-pane class="row" label="Evolution" name="Evolution">
        <Leads-Graph-Single-View-Card class="col-md-10"
                                      :barchart="barChart"
                                      :render="render"/>
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
import { Lead } from '../../../classes/datamodel'
  export default {
    name: 'single-company-view',
    data () {
      return {
        activeTab: this.$store.getters.leads.length && this.$store.getters.leads.find(l => l.status != 'submitted') > 0 ? 'Leads' : 'Affiliates',
        render: false
      }
    },
    computed: {
      toReceiveLabel () {
        let str = `To Receive`
        const leads = this.$store.getters.leads.filter(l => l.status == Lead._status.SUBMITTED.value)
        leads.length > 0 ? str += ` (${leads.length})` : null
        return str
      },
      barChart () {
        return {
          data: {
            labels: ['Jan\n72%', 'Feb\n55%', 'Mar\n81%', 'Apr\n84%', 'Mai\n89%','Jun\n18%',
            'Jul\n93%', 'Aug\n91%', 'Sep\n78%', 'Oct\n79%', 'Nov\n87%', 'Dec\n82%'],
            series: [
              [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895],
              [412, 243, 280, 580, 453, 353, 300, 364, 368, 410, 636, 695]
            ]
          },
          options: {
            seriesBarDistance: 6,
            axisX: {
              showGrid: false
            },
            height: '245px'
          },
          responsiveOptions: [
            ['screen and (max-width: 640px)', {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc (value) {
                  return value[0]
                }
              }
            }]
          ]
        }
      }
    },
    methods: {
      handleClick(tab, event) {
        //console.log(tab, event)
      }
    }, 
    watch: {
      activeTab: function(tab) {
        if (tab == 'Evolution') {
          this.render = true;
        }
      }
    }
  }
</script>

<style>

</style>
